import React, { SVGProps } from 'react'
export const ThirdDefaultCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M18.084 34.984c7.012-.008 14.252-.016 19.455-.016 4.675 0 12.763.008 20.196.016l4.41.005C67.725 34.995 72.363 35 74 35v1c-1.64 0-6.29-.005-11.88-.011l-4.386-.005c-7.433-.008-15.521-.016-20.195-.016-5.203 0-12.442.008-19.453.016l-1.01.001C10.428 35.993 4.085 36 0 36v-1c4.08 0 10.415-.007 17.057-.015h1.027Z"
      clipRule="evenodd"
    />
    <path
      fill="#7F7472"
      d="M36.696 1.661C24.652.951 11.845.215 0 3.021v-1C11.925-.804 24.564-.056 36.512.649l.205.012c.744.044 1.484.088 2.22.13 4.629.269 9.3-.027 14.012-.324 1.17-.074 2.341-.148 3.516-.214C62.349-.077 68.168-.224 74 1v1C68.305.805 62.392.922 56.52 1.25c-1.157.065-2.318.139-3.48.212-4.717.299-9.466.599-14.16.327l-2.184-.128Z"
    />
  </svg>
)
